export const getUpdatedCookieConsentTexts = (presentCookieConsentTexts, updatedCookieConsentTextData) => {
  let _presentCookieConsentTexts = presentCookieConsentTexts.slice();

  if (Array.isArray(updatedCookieConsentTextData)) {
    return getUpdatedCookieConsentTextsByMany(_presentCookieConsentTexts, updatedCookieConsentTextData);
  } else {
    return getUpdatedCookieConsentTextsByOne(_presentCookieConsentTexts, updatedCookieConsentTextData);
  }
};

const getUpdatedCookieConsentTextsByMany = (presentCookieConsentTexts, manyUpdatedCookieConsentTexts) => {
  for (let updatedConsentText of manyUpdatedCookieConsentTexts) {
    let index = presentCookieConsentTexts.findIndex(item => item.languages === updatedConsentText.languages);
    if (index === -1) {
      presentCookieConsentTexts.push(updatedConsentText);
    }
  }

  return presentCookieConsentTexts;
};

const getUpdatedCookieConsentTextsByOne = (presentCookieConsentTexts, singleUpdatedCookieConsentText) => {
  const index = presentCookieConsentTexts.findIndex(item => (item.languages && item.languages === singleUpdatedCookieConsentText.languages));
  if (index === -1) {
    presentCookieConsentTexts.push(singleUpdatedCookieConsentText);
  } else {
    Object.assign(presentCookieConsentTexts[index], singleUpdatedCookieConsentText);
  }

  return presentCookieConsentTexts;
};
